import React from 'react'
import { observer } from 'mobx-react'
import BoolField from 'bstrap-react-mobx-admin/field/bool'
import BoolInput from 'bstrap-react-mobx-admin/input/bool'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../../input/date'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import RegionsInput from '../../input/regions'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import moment from 'moment'
import { Button, Tabs, Tab } from 'react-bootstrap'
import HelpOverlay from '../../utils/helpOverlay'

function YTThumbF({ url }) {
  return (<img style={{ maxWidth: '400px' }} src={url} />)
}
const YTThumb = observer(YTThumbF)

const YoutubeInfoEditTable = ({ store, updateField, ...rest }) => {
  const handleActive = tab => {
    store.selectedTabYouTube = tab
  }
  const minDate = store.options.get('timeRestrictions') && store.options.get('timeRestrictions')[0] && store.options.get('timeRestrictions').reverse()[0].date
    ? moment(store.options.get('timeRestrictions').reverse()[0].date).add(1, 'days')
    : moment()

  const _YTAssetInfoForm = ({ state, record, updateFormField, errors }) => {
    const { stageOneRestricted } = store.timeRestriction.checkSubentity(store, state)
    const thisID = record.has('id') && record.get('id')

    return (
      <div className='row'>
        <fieldset disabled={stageOneRestricted}>
          <div className='col-xs-12'>
            <TextInput label={store.__('asset id')} attr={'asset_id'} record={record}
              onChange={updateFormField} errors={errors} />
            <TextInput label={store.__('name')} attr={'asset_name'} record={record}
              onChange={updateFormField} errors={errors} />
            <SelectInput label={store.__('asset type')} attr='asset_type' record={record}
              onChange={updateFormField} labelattr='text' valueattr='value'
              valueFilterFc={i => !i.text.includes('video')} disabled={stageOneRestricted}
              optionsrecord={store.options} optionsattr='UploadTypes' errors={errors} />
            <DateInput label={store.__('created at')} attr={'asset_created_dt'} record={record}
              onChange={updateFormField} errors={errors}
              minDate={minDate} disabled={stageOneRestricted} />
            <TextInput label={store.__('note')} attr={'note'} record={record}
              onChange={updateFormField} errors={errors} />
            {thisID && <TextInput label={store.__('source')} attr={'source'} record={record} disabled
              onChange={updateFormField} errors={errors} />}
          </div>
        </fieldset>
      </div>
    )
  }

  const _YTInfoForm = ({ state, record, updateFormField, errors }) => {
    const { stageOneRestricted, stageTwoRestricted } = store.timeRestriction.checkSubentity(store, state)
    return (
      <div className='row'>
        <div className='col-xs-12'>
          <div className='row'>
            <div className='col-sm-9'>
              <TextInput label={store.__('YouTube video ID')} attr={'film_platform_id'} record={record}
                onChange={updateFormField} errors={errors} disabled={stageOneRestricted} />
            </div>
            <div className='col-sm-2'>
              <Button className='btn btn-info' style={{ margin: '1.4em 0' }} disabled={stageOneRestricted}
                onClick={() => store.getYouTubeFilmInfo(record, updateFormField)}>
                <span className='glyphicon glyphicon-cloud-download' />&nbsp;{store.__('from API')}</Button>
            </div>
          </div>
          <TextInput label={store.__('title')} attr={'title'} record={record} disabled={stageOneRestricted}
            onChange={updateFormField} errors={errors} />
          <SelectInput label={store.__('YouTube Channel')} attr={'channel_id'} record={record} disabled={stageOneRestricted}
            onChange={updateFormField} optionsrecord={store.options} optionsattr={'Channels'}
            labelattr='text' valueattr='value' errors={errors} />
          <SelectInput label={store.__('video type')} attr='video_type' record={record}
            onChange={updateFormField} labelattr='text' valueattr='value'
            valueFilterFc={i => !i.text.includes('video')} disabled={stageOneRestricted}
            optionsrecord={store.options} optionsattr='UploadTypes' errors={errors} />
          <SelectInput label={store.__('Language of items downloaded from YouTube Data API saved as attributes')}
            attr={'language'} record={record} disabled={stageOneRestricted}
            onChange={updateFormField} optionsrecord={store.options} optionsattr={'Languages'}
            labelattr='text' valueattr='value' errors={errors} />
          <TextInput label={store.__('note')} attr={'note'} record={record} disabled={stageOneRestricted}
            onChange={updateFormField} errors={errors} />
          <SelectInput label={store.__('Audio language')} attr={'default_audio_language'} record={record}
            onChange={updateFormField} optionsrecord={store.options} optionsattr={'Languages'} disabled={stageOneRestricted}
            labelattr='text' valueattr='value' />
          <BoolInput label={store.__('private')} disabled={stageOneRestricted}
            attr={'private'} record={record} onChange={updateFormField} errors={errors} />
          <DateInput label={store.__('publish date')} attr={'publish_date'}
            record={record} onChange={updateFormField} errors={errors}
            minDate={minDate} disabled={stageOneRestricted} />
          <DateInput label={store.__('cancel date')} attr={'cancel_date'}
            record={record} onChange={updateFormField} errors={errors}
            minDate={minDate} disabled={stageTwoRestricted} />
          <RegionsInput label={store.__('region restrictions allowed')} attr={'region_restrictions_allowed'}
            record={record} onChange={updateFormField} errors={errors} hideCheckbox disabled={stageOneRestricted}
            optionsrecord={store.options} optionsattr={'Countries'} />
          <RegionsInput label={store.__('region restrictions blocked')} attr={'region_restrictions_blocked'}
            record={record} onChange={updateFormField} errors={errors} hideCheckbox disabled={stageOneRestricted}
            optionsrecord={store.options} optionsattr={'Countries'} />
          <div>
            <YTThumb url={store.cv.ytubePreviewSrc} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <Tabs onSelect={handleActive} defaultActiveKey={store.selectedTabYouTube || 1}>
        <Tab eventKey={1} title={
          <div>
            {store.__('YouTube assets')}
            <HelpOverlay store={store} path={'films/YT/assets'} />
          </div>}>
          <EmbededEntityInput
            store={store}
            attr={'youtube_asset_info'}
            edit_title={store.__('Edit YouTube asset info')}
            add_title={store.__('Add YouTube asset info')}
            fields={[
              (attr, row) => {
                const DetailLink = ({ text }) => (
                  <React.Fragment>
                    <a href={`https://studio.youtube.com/asset/${text}/metadata/overview?o=V6sUCxWfKb0HkJZl-8SRxw`}
                      target="_blank" rel="noreferrer"
                      title={store.__('Open link in new tab')}
                      className="text-muted link-icon"
                      style={{ padding: '0' }}>
                      <i className="glyphicon glyphicon-new-window" />
                    </a>&nbsp;&nbsp;{text}
                  </React.Fragment>
                )
                return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
              },
              (attr, row) => (<TextField attr={attr} val={row[attr]} />),
              (attr, row) => (
                <OptionsField attr={attr} val={row[attr]}
                  options={store.options.get('UploadTypes')}
                  labelattr='text'
                  valueattr='value' />
              ),
              (attr, row) => (<TextField attr={attr} val={row[attr]} />),
              (attr, row) => (<TextField attr={attr} val={row[attr]} />),
              (attr, row) => (<TextField attr={attr} val={row[attr]} />)
            ]}
            rowId={(row) => (row.asset_id)}
            EditForm={_YTAssetInfoForm} {...rest}
          />
        </Tab>
        <Tab eventKey={2} title={
          <div>
            {store.__('YouTube videos')}
            <HelpOverlay store={store} path={'films/YT/videos'} />
          </div>}>
          <EmbededEntityInput
            store={store}
            attr={'youtubeinfo'}
            edit_title={store.__('edit YouTube video ID record')}
            add_title={store.__('add YouTube video ID record')}
            fields={[
              (attr, row) => {
                const DetailLink = ({ text }) => (
                  <React.Fragment> {/* https://www.youtube.com/watch?v= */}
                    <a href={`https://studio.youtube.com/video/${text}/edit?o=V6sUCxWfKb0HkJZl-8SRxw`}
                      target="_blank" rel="noreferrer"
                      title={store.__('Open link in new tab')}
                      className="text-muted link-icon"
                      style={{ padding: '0' }}>
                      <i className="glyphicon glyphicon-new-window" />
                    </a>&nbsp;&nbsp;{text}
                  </React.Fragment>
                )
                return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
              },
              (attr, row) => {
                const DetailLink = ({ text }) => (
                  <React.Fragment>
                    <a href={`https://www.youtube.com/channel/${text}`}
                      target="_blank" rel="noreferrer"
                      title={store.__('Open link in new tab')}
                      className="text-muted link-icon"
                      style={{ padding: '0' }}>
                      <i className="glyphicon glyphicon-new-window" />
                    </a>&nbsp;&nbsp;<OptionsField
                      attr={attr}
                      options={store.options.get('Channels')}
                      val={row[attr]}
                      labelattr='text'
                      valueattr='value'
                      Component={({ text }) =>
                        <span style={{ display: 'inline' }}>{text}</span>
                      }
                    />
                  </React.Fragment>
                )
                return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
              },
              (attr, row) => (
                <OptionsField attr={attr} val={row[attr]}
                  options={store.options.get('UploadTypes')}
                  labelattr='text'
                  valueattr='value' />
              ),
              (attr, row) => (<TextField attr={attr} val={row[attr]} />),
              (attr, row) => (
                <OptionsField
                  attr={attr}
                  val={row[attr]}
                  options={store.options.get('Languages')}
                  labelattr='text'
                  valueattr='value' />
              ),
              (attr, row) => (<TextField attr={attr} val={row[attr]} />), // note
              (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
              (attr, row) => (<DateField attr={attr} val={row[attr]} />), // publishedAt
              (attr, row) => (<DateField attr={attr} val={row[attr]} />),
              (attr, row) => (<TextField attr={attr} val={row[attr]} />),
              (attr, row) => (<TextField attr={attr} val={row[attr]} />)
            ]}
            rowId={(row) => (row.film_platform_id)}
            EditForm={_YTInfoForm} {...rest}
          />
        </Tab>
      </Tabs>
    </div>
  )
}
export default observer(YoutubeInfoEditTable)
